import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  LinearProgress,
  Typography,
  Checkbox,
} from '@mui/material';
import { withRouter } from 'react-router-dom';

const styles = {
  progressBarContainer: {
    marginLeft: '12px',
    marginTop: '4px',
  },
  progressSummary: {
    fontSize: '12px',
    float: 'right',
    padding: 0,
  },
  progressBar: {
    height: '6px',
    marginRight: '12px',
    backgroundColor: '#d9d9d9',
    marginTop: '6px',
  },
  checkbox: {
    color: '#1976D2',
    marginLeft: '12px',
    padding: '0',
    marginBottom: '10px',
  },
  label: {
    width: '30%',
    marginLeft: '12px',
    fontSize: '12px',
  },
};

function BaseRunTaskProgress({
  label, completed, recommended, checked, onChange,
}) {
  const getValue = () => {
    if (recommended === 0 || completed === 0) {
      return 0;
    }
    return (completed / recommended) * 100;
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Checkbox
          style={styles.checkbox}
          size="small"
          checked={checked}
          onChange={onChange}
        />
        <Typography style={styles.label}>{label}</Typography>
        <div style={{ width: '100%' }}>
          <Box sx={{ width: '100%' }} style={styles.progressBarContainer}>
            <LinearProgress
              variant="determinate"
              value={getValue()}
              style={styles.progressBar}
            />
          </Box>
          <Typography style={styles.progressSummary}>
            {`${completed}/${recommended}`}
          </Typography>
        </div>
      </div>
    </>
  );
}

BaseRunTaskProgress.defaultProps = {};
BaseRunTaskProgress.propTypes = {
  recommended: PropTypes.number.isRequired,
  completed: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const RunTaskProgress = withRouter(BaseRunTaskProgress);
export { BaseRunTaskProgress, RunTaskProgress };
